<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66667 5.5C5.47005 5.5 4.5 6.47005 4.5 7.66667V8.05556H19.5V7.66667C19.5 6.47005 18.53 5.5 17.3333 5.5H6.66667ZM3.5 7.66667V8.55556V14.7778C3.5 16.5267 4.91776 17.9444 6.66667 17.9444H10.2222C10.4984 17.9444 10.7222 17.7206 10.7222 17.4444C10.7222 17.1683 10.4984 16.9444 10.2222 16.9444H6.66667C5.47005 16.9444 4.5 15.9744 4.5 14.7778V9.05556H19.5V14.7778C19.5 15.0539 19.7239 15.2778 20 15.2778C20.2761 15.2778 20.5 15.0539 20.5 14.7778V8.55556V7.66667C20.5 5.91777 19.0822 4.5 17.3333 4.5H6.66667C4.91777 4.5 3.5 5.91777 3.5 7.66667ZM15.9102 21.0747C15.8196 21.1658 15.6942 21.2222 15.5556 21.2222C15.423 21.2222 15.2958 21.1695 15.202 21.0758L12.5354 18.4091C12.3401 18.2138 12.3401 17.8973 12.5354 17.702C12.7306 17.5067 13.0472 17.5067 13.2425 17.702L15.0556 19.5151V14.5C15.0556 14.2239 15.2794 14 15.5556 14C15.8317 14 16.0556 14.2239 16.0556 14.5V19.5151L17.8687 17.702C18.064 17.5067 18.3805 17.5067 18.5758 17.702C18.7711 17.8973 18.7711 18.2138 18.5758 18.4091L15.9102 21.0747Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "#768391"
    }
  }
};
</script>
